module.exports = __webpack_public_path__ + "img/Logo_Volkskultur_CMYK-1.2191be39.jpg";